import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { getCategories } from '../../utils/liveCasinoSort';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IEzugiDTO, IEzugiGetToken } from '../../types/interfaces/LiveCasino/EzugiDTO';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IEzugiDTO[]>): ISlotViewItem[] =>
    data.map((item: IEzugiDTO) => ({
      id: item.TableId.toString(),
      gameId: item.TableId.toString(),
      gameName: item.TableName,
      provider: 'evolution',
      description: item.TableName,
      type: CasinoType.liveCasino,
      imageUrl: `https://ganamos.co/images/ezugi/${item.PictureLink}`,
      routeProvider: 'evolution',
      tab: getCategories(item.TableName, 'evolution'),
    }));

  convertGameUrl = ({ data }: IGetGameUrl<IEzugiGetToken, unknown>) => data.frame_url;
}
export default Converter;
